export let EmbedLogoVisibility;
(function (EmbedLogoVisibility) {
  EmbedLogoVisibility["CONTROL_BAR"] = "CONTROL_BAR";
  EmbedLogoVisibility["ALWAYS"] = "ALWAYS";
})(EmbedLogoVisibility || (EmbedLogoVisibility = {}));
//# sourceMappingURL=embed-logo-visibility.js.map